module.exports = __webpack_public_path__ + "static/media/CHF-Primary_RGB.1df1c42f.jpg";